module.exports = {"sewingpattern":{"id":"sewingpattern","title":"Sewing Pattern","selectedValues":{"processing time":"processed within 3-5 days","scope of delivery":"Multisize pattern without fabric"},"productData":{"processingtime":"processed within 3-5 days","delivery":"Multisize pattern without fabric"}},"fabric":{"id":"fabric","title":"Fabric","selectedValues":{"scope of delivery":"Fabric without sewing pattern"},"productData":{"delivery":"Fabric without sewing pattern"}},"schnoff":{"id":"schnoff","title":"Fabric + Sewing Pattern","selectedValues":{},"productData":{}}}


//////////////////
// WEBPACK FOOTER
// ./src/data/products/en-EN.json
// module id = VS5c
// module chunks = 58